












import {Component, Prop, Emit, Vue} from "vue-property-decorator"

@Component
export default class Pagination extends Vue {

  @Prop({type: Number, default: 0}) private page!: number

  @Prop({type: Number, default: 0}) private page_num!: number

  @Prop({type: Number, default: 2}) private slide_num!: number

  get pages(): number[] {
    const pages = []
    for (let p = this.start; p <= this.end; p++) {
      pages.push(p)
    }
    return pages
  }

  get start(): number {
    if (this.page - this.slide_num > 1) {
      return this.page - this.slide_num
    }
    return 1
  }

  get end(): number {
    if (this.page + this.slide_num < this.page_num) {
      return this.page + this.slide_num
    }
    return this.page_num
  }

  @Emit("click")
  onClickPager(p: number) {
    return p
  }

  @Emit("prev")
  onClickPrev() {
  }

  @Emit("next")
  onClickNext() {
  }
}
